// Settings → Expense accounts (V-10): the Application API's routes for the pack's expense accounts and the business's
// own, which run the same commands chat runs (#605).
import { call, type Fetch } from "../../http.js";
import type { ListMay } from "../dimensions/api.js";

/** An expense account: the pack's (read-only) or the business's own. */
export interface ExpenseAccount {
  readonly code: string;
  readonly name: string;
  readonly section: string;
  readonly group: string;
  readonly own: boolean;
  readonly retired: boolean;
}

export interface ExpenseAccounts {
  readonly may: ListMay;
  /** The statement groups the pack's chart has under expenses, in its order. */
  readonly groups: readonly string[];
  readonly accounts: readonly ExpenseAccount[];
}

export interface ExpenseAccountsApi {
  list(): Promise<ExpenseAccounts>;
  add(input: { name: string; group: string }): Promise<ExpenseAccount>;
  rename(code: string, name: string): Promise<ExpenseAccount>;
  retire(code: string): Promise<ExpenseAccount>;
}

export function createExpenseAccountsApi(fetcher: Fetch): ExpenseAccountsApi {
  return {
    list: () => call<ExpenseAccounts>(fetcher, "/api/settings/expense-accounts"),
    add: (input) => call<ExpenseAccount>(fetcher, "/api/settings/expense-accounts", { json: input }),
    // Each path written out whole: tests/api-routes/ checks every one the web app calls is one the api serves.
    rename: (code, name) =>
      call<ExpenseAccount>(fetcher, `/api/settings/expense-accounts/${encodeURIComponent(code)}/rename`, {
        json: { name },
      }),
    retire: (code) =>
      call<ExpenseAccount>(fetcher, `/api/settings/expense-accounts/${encodeURIComponent(code)}/retire`, {
        json: {},
      }),
  };
}
